import React, { useEffect, useState } from "react";
import { api } from "@/api/client";
import { useTranslation } from "react-i18next";

// Shared notification banner. Font/border are red to make announcements
// impossible to miss (per business request). Fetches active notifications
// once when mounted; safe to drop into any authenticated screen.
export default function NotificationBanner({ style = {}, testIdPrefix = "notif" }) {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <div className="notif-stack" data-testid={`${testIdPrefix}-list`} style={style}>
      {items.map((n) => (
        <div key={n.id} className="notif-card" data-testid={`${testIdPrefix}-item-${n.id}`}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
            <div className="notif-icon">📢</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 2, letterSpacing: 0.3 }}>
                {t("common.announcements")}
              </div>
              <div style={{ whiteSpace: "pre-wrap", fontSize: 14, fontWeight: 500 }}>{n.message}</div>
              <div className="notif-meta" style={{ fontSize: 11, marginTop: 4 }}>
                {n.created_by_name || "管理者"} · {n.created_at ? new Date(n.created_at).toLocaleString() : ""}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
